import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import LanguageBar from './components/LanguageBar';
import Home from './pages/Home';
import Whitepaper from './pages/Whitepaper';
import Ultra from './pages/Ultra';
import Architecture from './pages/Architecture';
import Tokenomics from './pages/Tokenomics';
import Roadmap from './pages/Roadmap';
import Ecosystem from './pages/Ecosystem';
import Team from './pages/Team';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Disclaimer from './pages/Disclaimer';

function App() {
  return (
    <LanguageProvider>
      <ThemeProvider>
        <div className="App">
          <LanguageBar />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/whitepaper" element={<Whitepaper />} />
              <Route path="/ultra" element={<Ultra />} />
              <Route path="/architecture" element={<Architecture />} />
              <Route path="/tokenomics" element={<Tokenomics />} />
              <Route path="/roadmap" element={<Roadmap />} />
              <Route path="/ecosystem" element={<Ecosystem />} />
              <Route path="/team" element={<Team />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
            </Routes>
          </BrowserRouter>
        </div>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
